import React from "react";
import { Outlet, Navigate, useLocation, matchPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { roleBaseAccessconfig } from "./roleBaseAccessconfig";

const PrivateRoute = () => {
  const location = useLocation();
  const {
    token: isAuthenticated,
    userData: { currentRoleName },
  } = useSelector((state) => state.loginSlice);

  const allowedPaths = roleBaseAccessconfig[currentRoleName] || [];
  const currentPath = location.pathname;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ redirectTo: currentPath }} />;
  }

  const isPathAllowed = allowedPaths.find((allowedPath) =>
    matchPath({ path: allowedPath, end: true }, currentPath)
  );

  if (!isPathAllowed) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "50px",
          color: "#f44336",
        }}
      >
        <h1>Unauthorized Access</h1>
      </div>
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
